export const SET_ORDERS = 'SET_ORDERS';
export const SET_STATUSES = 'SET_STATUSES';
export const SET_ORDER = 'SET_ORDER';
export const SET_JOINED_DISPUTE = 'SET_JOINED_DUSPITE';
export const SET_ORDER_MESSAGES = 'SET_ORDER_MESSAGES';
export const CLEAR_ORDER_MESSAGES = 'CLEAR_ORDER_MESSAGES';
export const SET_DISPUTE_COUNT = 'SET_DISPUTE_COUNT';

export const UNSET_STATUSES = 'UNSET_STATUSES';
